/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MelcoModelsCustomWarning,
    MelcoModelsCustomWarningFromJSON,
    MelcoModelsCustomWarningFromJSONTyped,
    MelcoModelsCustomWarningToJSON,
    MelcoModelsSupplierProduct,
    MelcoModelsSupplierProductFromJSON,
    MelcoModelsSupplierProductFromJSONTyped,
    MelcoModelsSupplierProductToJSON,
} from './';

/**
 * 
 * @export
 * @interface MelcoModelsGenericList1MelcoModelsSupplierProduct
 */
export interface MelcoModelsGenericList1MelcoModelsSupplierProduct {
    /**
     * 
     * @type {Array<MelcoModelsSupplierProduct>}
     * @memberof MelcoModelsGenericList1MelcoModelsSupplierProduct
     */
    list: Array<MelcoModelsSupplierProduct>;
    /**
     * 
     * @type {Array<MelcoModelsCustomWarning>}
     * @memberof MelcoModelsGenericList1MelcoModelsSupplierProduct
     */
    warning_list?: Array<MelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof MelcoModelsGenericList1MelcoModelsSupplierProduct
     */
    total: number;
}

export function MelcoModelsGenericList1MelcoModelsSupplierProductFromJSON(json: any): MelcoModelsGenericList1MelcoModelsSupplierProduct {
    return MelcoModelsGenericList1MelcoModelsSupplierProductFromJSONTyped(json, false);
}

export function MelcoModelsGenericList1MelcoModelsSupplierProductFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsGenericList1MelcoModelsSupplierProduct {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(MelcoModelsSupplierProductFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(MelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function MelcoModelsGenericList1MelcoModelsSupplierProductToJSON(value?: MelcoModelsGenericList1MelcoModelsSupplierProduct | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(MelcoModelsSupplierProductToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(MelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


